import { LanguageEnum } from '@/website/contexts/AppContext';
import { getLanguageCookie } from '@/website/util/cookies';

export default function PromotionFloatingButton({ discount, onClick }: { discount: number; onClick: () => void }) {
  const discountDisplay = Number(discount * 100).toFixed();
  const currentLanguage = getLanguageCookie();
  const renderText = new Map([
    [LanguageEnum.EN, `Save ${discountDisplay}% today!`],
    [LanguageEnum.FR, `Économiser ${discountDisplay}% aujourd'hui!`],
    [LanguageEnum.ES, `Ahorrar ${discountDisplay}% hoy!`],
    [LanguageEnum.PT, `Economize ${discountDisplay}% hoje!`],
    [LanguageEnum.DE, `Spar ${discountDisplay}% heute!`],
    [LanguageEnum.NL_BE, `Bespaar ${discountDisplay}% vandaag!`],
    [LanguageEnum.NL_NL, `Bespaar ${discountDisplay}% vandaag!`],
  ]);

  return (
    <button
      className="promotion-floating-button text-md fixed bottom-5 right-5 z-50 rounded-full px-5 py-3 font-black text-white shadow-md transition-all duration-300 hover:shadow-lg md:bottom-10 md:right-10 md:px-8 md:py-4 md:text-lg"
      onClick={onClick}
    >
      {renderText.get(currentLanguage as any) || renderText.get(LanguageEnum.EN)}
    </button>
  );
}
